import React from 'react'

import Header from './Header'
import List from './List'

const NotificationCenter = ({ closeModal }) => (
  <div className="background-shade-100 radius-large">
    <Header />
    <div className="u-grid-cell-size-limit" style={{ height: '70vh' }}>
      <List onClickRow={closeModal} />
    </div>
  </div>
)

export default NotificationCenter
